module.exports = __webpack_public_path__ + "images/district_back.1790731042052.png";